<template>
    <v-main class="pt-0">
        <cover-image src="/images/covers/graffiti-cover-desktop.jpg"
                     phone-src="/images/covers/graffiti-cover-phone.jpg"
                     tablet-src="/images/covers/graffiti-cover-tablet.jpg"
                     :opacity="0.2"
                     secondary-color="#ffc947" color="#FF8A2F"
                     :next-section-id="shoots[0].slug"
                     :title="title"
                     subtitle="Model"
                     :description="description"
                     action-text="Let's go!"
                     :action-path="`#${shoots[0].slug}`"
                     full-height main left/>

        <cover-image v-for="shoot in shoots" :key="shoot.slug"
                     :id="shoot.slug"
                     :youtube-id="shoot.previewYoutubeId"
                     :background-color="shoot.primaryColor"
                     :color="shoot.primaryColor"
                     :secondary-color="shoot.secondaryColor"
                     :title="shoot.title"
                     :subtitle="shoot.date"
                     action-text="Zum Video"
                     :action-path="`/video-shoots/${shoot.slug}`"
                     left>

            <template #description>
                <shoot-artist-list :shoot="shoot"/>
            </template>

        </cover-image>

        <app-footer dark absolute/>

    </v-main>
</template>

<script setup lang="ts">
import {VideoShootPreview} from "../../types/models/VideoShoot";

const {data: shoots}: {data: VideoShootPreview[]} = await useApiFetch('listVideoShoots', [
    'title',
    'slug',
    'date',
    'primaryColor',
    'secondaryColor',
    'previewYoutubeId',
    'cameraArtist {name url}',
    'makeupArtist {name url}',
    'hairArtist {name url}',
    'voiceArtist {name url}',
    'castingAgency {name url}',
], 'sort: date_DESC');

const title = 'Video Shoots';
const description = 'Sieh Dir meine bisherigen Drehs an und erhalte Informationen über Mitwirkende. Get it! :-)';

useMeta({
    title: title,
    description: description,
})

</script>